import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, StyledSpinner } from './Styled';

const Loader = (props) => {
  const { className } = props;
  return (
    <Wrapper className={className}>
      <StyledSpinner viewBox="0 0 50 50">
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        />
      </StyledSpinner>
    </Wrapper>
   );
};

Loader.propTypes = {
  className: PropTypes.string
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/common/Loader/Loader.js